import { useState } from "react";

export function useError() {
  const [error, setError] = useState<Error | null>(null);

  const handleError = (err: unknown) => {
    const errorObj = err instanceof Error ? err : new Error(String(err));
    setError(errorObj);
    console.error(errorObj);
  };

  const clearError = () => setError(null);

  return { error, handleError, clearError };
}
